/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSupplierDto } from '../models/CreateSupplierDto';
import type { UpdateSupplierDto } from '../models/UpdateSupplierDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SuppliersService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static suppliersControllerCreate(requestBody: CreateSupplierDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/suppliers',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all suppliers
   * @param page Page number
   * @param limit Items per page
   * @param searchName Search by supplier name
   * @param searchEmail Search by supplier email
   * @param status Filter by status
   * @returns any Returns all suppliers
   * @throws ApiError
   */
  public static suppliersControllerFindAll(
    page?: number,
    limit?: number,
    searchName?: string,
    searchEmail?: string,
    status?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/suppliers',
      query: {
        page: page,
        limit: limit,
        searchName: searchName,
        searchEmail: searchEmail,
        status: status,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static suppliersControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/suppliers/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static suppliersControllerUpdate(
    id: string,
    requestBody: UpdateSupplierDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/suppliers/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete a supplier
   * @param id
   * @returns any Supplier deleted successfully
   * @throws ApiError
   */
  public static suppliersControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/suppliers/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Cannot delete supplier - it is being used by products`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Supplier not found`,
      },
    });
  }
}
